import React, { useEffect, useState } from 'react';
import { API_ENDPOINTS } from '../../utils/apiEndPoints';
import defaultInstance from '../../axiosHelper';
import ScreeningFilter from './ScreeningFilter';
import moment from 'moment';
import { getSessionFilter } from '../../utils/sessionStorage';

const ScreeningCount = () => {

    const [allData, setAllData] = useState([]);
    const [todayScreenings, setTodayScreenings] = useState(0);
    const [totalScreeningsTillDate, setTotalScreeningsTillDate] = useState(0);
    const [totalScreenCount, setTotalScreenCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [filterDates, setFilterDates] = useState({
        from_date: '',
        to_date: ''
    });

    const fetchScreeningReport = async () => {
        try {
            const filterData = getSessionFilter('screeningFilter') || {
                from_date: moment().subtract(1, 'years').format('YYYY-MM-DD'),
                to_date: moment().format('YYYY-MM-DD'),
                search_term: '',
                page_limit: 4000,
                skip_count: 0
            };

            // Update local state for display
            setFilterDates({
                from_date: filterData.from_date,
                to_date: filterData.to_date
            });

            const params = {
                from_date: filterData.from_date,
                to_date: filterData.to_date,
                search_term: filterData.search_term,
                page_limit: filterData.page_limit,
                skip_count: filterData.skip_count || '0'
            };

            const response = await defaultInstance.get(API_ENDPOINTS.SCREENING_REPORT, { params });

            if (response?.data?.success) {
                const data = response?.data?.data?.length > 0 ? response?.data?.data : [];
                const totalScreenCount = data?.reduce((sum, item) => Number(sum) + Number(item?.screen_count || 0), 0);

                setAllData(data);
                setTotalScreenCount(totalScreenCount);
                setTodayScreenings(response?.data?.today_screenings || 0);
                setTotalScreeningsTillDate(response?.data?.total_screenings_till_date || 0);
            }
        } catch (error) {
            console.error('Error fetching screening report:', error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchScreeningReport();

        // Listen for storage events to handle changes from other tabs/windows
        const handleStorageChange = (e) => {
            if (e.key === 'screeningFilter') {
                fetchScreeningReport();
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, [])

    const headers = ['Field Coordinator Name', 'District', 'Village', 'Health Facility', 'Screen Count']
    const countHeaders = [
        'Today Screening',
        `Screening: ${moment(filterDates.from_date, 'YYYY-MM-DD').format('DD MMM YYYY')} - ${moment(filterDates.to_date, 'YYYY-MM-DD').format('DD MMM YYYY')}`,
        'Total Screening'
    ];

    if (isLoading) {
        return (<div style={{ width: '98vw', height: '95vh', position: 'absolute', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
            <img style={{ width: 50, height: 50 }} src='./loading.gif' alt='loading' />
        </div>)
    }

    return (
        <div className="role-container">
            <ScreeningFilter />
            <div style={{ marginTop: 40 }} className="fm-item-container">
                <table className="fm-item-table">
                    <thead>
                        <tr>
                            {countHeaders.map((countTh, idx) => {
                                return (
                                    <th key={idx} style={{ backgroundColor: '#217cc070' }}>{countTh}</th>
                                )
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ fontSize: '20px', fontWeight: 700 }}>{todayScreenings}</td>
                            <td style={{ fontSize: '20px', fontWeight: 700 }}>{totalScreenCount}</td>
                            <td style={{ fontSize: '20px', fontWeight: 700 }}>{totalScreeningsTillDate}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style={{ marginTop: 40 }} className="fm-item-container">
                <table className="fm-item-table">
                    <thead>
                        <tr>
                            {headers.map((th, idx) => {
                                return (
                                    <th key={idx} style={{ backgroundColor: '#217cc070' }}>{th}</th>
                                )
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {allData?.map((item, idx) => {
                            return (
                                <tr key={idx}>
                                    <td>{item?.field_coordinator_name || 'Not filled'}</td>
                                    <td>{item?.district || 'Not filled'}</td>
                                    <td>{item?.village || 'Not filled'}</td>
                                    <td>{item?.health_facility || 'Not filled'}</td>
                                    <td>{item?.screen_count || '0'}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default ScreeningCount
